export default __webpack_public_path__ + "static/media/test-image2.84cf4d51.png";